import moment, { Moment } from "moment";

export type { Moment };
export default moment;
